import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerLeftDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowCornerLeftDown"><Path d="M20 2V3.5H9.5V17.6895L12.75 14.4395L13.8105 15.5L8.75 20.5605L3.68945 15.5L4.75 14.4395L8 17.6895V2H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerLeftDown;
